<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <div class="row">
            <div class="col-md-10">
                <div class="card flex-fill">
                    <b-tabs small card>
                        <b-tab active class="p-2">
                            <template #title>
                                <b-icon icon="calendar-date" variant="primary"></b-icon>
                                <span class="ms-2">Filtrar por fecha de generación</span>
                            </template>
                            <DateFilter @filter="fetchStatements" :initialRange="dateRange" :hideClear="true">
                            </DateFilter>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>

            <div class="col-md-2 ps-0 d-flex">
                <div class="align-items-center flex-grow-1">
                    <div class="h-100 d-flex flex-column justify-content-center">
                        <PrintWindow class="w-100 mb-2" tooltip="Imprimir tabla" title="Reporte de Declaraciones">
                            <CompanyInformationCard :title="reportTitle" class="mb-3"></CompanyInformationCard>
                            <StatementReportTable :items="statements" />
                        </PrintWindow>
                        <StatementReportExcel class="mt-2" :items="statements" />

                    </div>
                </div>
            </div>
        </div>

        <StatementReportTable class="m-3" :items="statements"></StatementReportTable>
    </div>
</template>

<script>
import DateFilter from '@/components/shared/Filters/Date-filter.vue'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import StatementReportTable from './StatementReport/Statement-report-table.vue'
import PrintWindow from '@/components/shared/Print-window.vue'
import { mapActions } from 'vuex'
import { addDays, formatDateInput } from '@/plugins/complianceScripts/index.js'
import CompanyInformationCard from '../shared/Company-information-card.vue'
import StatementReportExcel from './StatementReport/Statement-report-excel.vue'

export default {
    name: 'StatementReport',

    components: {
        DateFilter,
        AlertDismiss,
        StatementReportTable,
        PrintWindow,
        CompanyInformationCard,
        StatementReportExcel
    },

    data() {
        const today = new Date()
        const sevenDaysAgo = addDays(today, -7)

        return {
            dateRange: {
                startDate: formatDateInput(sevenDaysAgo) + 'T00:00:00.000Z',
                endDate: formatDateInput(today) + 'T23:59:59.999Z'
            },
            statements: null
        }
    },

    async mounted() {
        await this.fetchStatements(this.dateRange)
    },

    computed: {
        reportTitle() {
            return `Declaraciones: (${this.formatDateOnly(this.dateRange.startDate)} - ${this.formatDateOnly(this.dateRange.endDate)})`;
        }
    },

    methods: {
        ...mapActions([
            'getAllStatementsByDate',
            'getAllVisitorForStatementId',
            'getAllUnvisitedForStatementId'
        ]),

        formatDateOnly(date) {
            if (!date) return '';
            const fechaHora = new Date(date);
            return fechaHora.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        },

        async fetchStatements(range) {
            this.dateRange = range;

            let result = await this.getAllStatementsByDate({
                initDate: range.startDate,
                finalDate: range.endDate
            });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message, "danger");
                return;
            }

            this.statements = result.data.map(statement => {
                return {
                    declarantMail: statement.declarant.mail,
                    declarantName: statement.declarant.name,
                    answers: statement.questionAndAnswers,
                    ...statement
                }
            });
        }
    }
}
</script>

<style></style>